export enum ExamPublisingTabTypes {
    isQuestionGraterThanZero = 'isQuestionGraterThanZero',
    isSessionQuestionCountGraterEqualThanExamQuestionCount = 'isSessionQuestionCountGraterEqualThanExamQuestionCount',
    isValidSessionDates = 'isValidSessionDates',
    sessionEndDateIsNotExpired = 'sessionEndDateIsNotExpired',
    isStudentGraterThanZero = 'isStudentGraterThanZero',
    isWeightingOk = 'isWeightingOk',
    prePopulateCount = 'prePopulateCount',
}

export function DefineDefaultTab(props: any): string {
    if (!(props.publishDatas && props.publishDatas.isQuestionGraterThanZero)) {
        return ExamPublisingTabTypes.isQuestionGraterThanZero;
    } else if (!(props.publishDatas && props.publishDatas.isSessionQuestionCountGraterEqualThanExamQuestionCount)) {
        return ExamPublisingTabTypes.isSessionQuestionCountGraterEqualThanExamQuestionCount;
    } else if (!(props.publishDatas && props.publishDatas.isValidSessionDates)) {
        return ExamPublisingTabTypes.isValidSessionDates;
    } else if (!(props.publishDatas && props.publishDatas.sessionEndDateIsNotExpired)) {
        return ExamPublisingTabTypes.sessionEndDateIsNotExpired;
    } else if (!(props.publishDatas && props.publishDatas.isStudentGraterThanZero)) {
        return ExamPublisingTabTypes.isStudentGraterThanZero;
    } else if (!(props.publishDatas && props.publishDatas.isWeightingOk)) {
        return ExamPublisingTabTypes.isWeightingOk;
    } else {
        return ExamPublisingTabTypes.prePopulateCount;
    }
}